<div class="wrapper" [class.isPrinting]="printService.isPrinting">
  <!-- <ngx-ui-loader [class.d-none]="!show"></ngx-ui-loader> -->
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  <router-outlet name="print"></router-outlet>
  <div
    class="app-container"
    [ngClass]="{
      'app-container--hide-nav': !isNavVisable,
      'app-container--collapse-nav': isNavCollapsed
    }"
  >
    <app-header *ngIf="isNavVisable"></app-header>

    <app-common-sidebar
      (toggleSidebar)="isNavCollapsed = $event"
    ></app-common-sidebar>

    <div class="app-container_page">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
      <router-outlet name="print"></router-outlet>
    </div>
  </div>
</div>
